import React from "react";
import {  Pagination } from "@mui/material";


const CustomPagination = (props:any) => {
  // console.log('CustomPagination props',props)
  
  return (
      <Pagination
        showFirstButton
        showLastButton
        color="primary"
        count={props.pagination.total_pages}
        page={props.pagination.current_page}
        onChange={(e:React.ChangeEvent<unknown>,page:number) => props.goPage(page)}
        
      />
    
  );

}

export default CustomPagination;